"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = require("react-redux");

var _components = require("components");

var _AppSideEffects = require("../AppSideEffects/AppSideEffects");

var _AppSideEffects2 = _interopRequireDefault(_AppSideEffects);

var _subscriptions = require("redux/modules/subscriptions");

var subscriptionService = _interopRequireWildcard(_subscriptions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CancelSubscriptionPopup = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    subscription: state.user.subscription
  };
}, (0, _extends3.default)({}, subscriptionService)), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(CancelSubscriptionPopup, _React$Component);

  function CancelSubscriptionPopup(props) {
    (0, _classCallCheck3.default)(this, CancelSubscriptionPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CancelSubscriptionPopup.__proto__ || (0, _getPrototypeOf2.default)(CancelSubscriptionPopup)).call(this, props));

    _this.state = {
      successful: false,
      cancelling: false
    };

    _this.onCancelled = _this.onCancelled.bind(_this);
    _this.onAborted = _this.onAborted.bind(_this);
    return _this;
  }

  // isCancelling(isCancelling) {
  //   this.setState({
  //     cancelling: isCancelling,
  //   });
  // }

  (0, _createClass3.default)(CancelSubscriptionPopup, [{
    key: "onCancelled",
    value: function onCancelled() {
      this.context.dialogs.custom(_react2.default.createElement(
        _AppSideEffects2.default,
        null,
        _react2.default.createElement(_components.FeedbackPopup, { onCloseYes: this.props.onCloseYes })
      ));
      // this.isCancelling(true);
      // this.props.cancelSubscription().then(
      //   () => {
      //     this.isCancelling(false);
      //     this.props.onCloseYes();
      //   },
      //   () => {
      //     this.isCancelling(false);
      //     this.props.onCloseYes();
      //   }
      // );
    }
  }, {
    key: "onAborted",
    value: function onAborted() {
      this.props.onCloseYes();
    }
  }, {
    key: "render",
    value: function render() {
      var cancelling = this.state.cancelling;
      var expiresAt = this.props.subscription.expiresAt;

      var expiryDate = (0, _moment2.default)(expiresAt).format("MMMM Do, YYYY");

      return _react2.default.createElement(
        _AppSideEffects2.default,
        null,
        _react2.default.createElement(_components.CancelSubscription, {
          icon: "/quixel_2080_logo.png",
          date: expiryDate,
          onCancelSubscriptionClick: this.onCancelled,
          onKeepSubscriptionClick: this.onAborted,
          cancelling: cancelling,
          drops: this.props.drops,
          license: this.props.license
        })
      );
    }
  }]);
  return CancelSubscriptionPopup;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class);
exports.default = CancelSubscriptionPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CancelSubscriptionPopup/CancelSubscriptionPopup.js
// module id = 2575
// module chunks = 0